import {Component} from "react";
import TextLabel from "../../../controls/TextLabel/TextLabel.mjs";
import {Alert, Button, ButtonGroup, Progress} from "reactstrap";
import Glob from "../../../libs/Glob.mjs";
import appLib from "../../../libs/appLib.mjs";
import ChevronLeftIcon from "../../../media/images/ChevronLeftIcon.mjs";
import PlayIcon from "../../../media/images/PlayIcon.mjs";
import AppPerimeterIcon from "../../../media/app-images/AppPerimeterIcon.mjs";
import AppSynthDataIcon from "../../../media/app-images/AppSynthDataIcon.mjs";
import "./SimulationFlowReady.css";
import ChevronRightIcon from "../../../media/images/ChevronRightIcon.mjs";
import AssociazioniStrategicheSoggetto from "../../../ComponentParts/AssociazioniStrategiche/AssociazioniStrategicheSoggetto.mjs";

const prefix = 'SimulationFlowReady';

const scoreClass = v => {
	if ( v >= 0.9 ) return "value-score value-score-high";
	if ( v >= 0.5 ) return "value-score value-score-medium";
	return "value-score value-score-low";
}

const ParseType2 = class extends Component {
	constructor(props) {
		super(props);
		const resources= props.simul?.trigger?.preparsed ?? [];
		this.state = {
			peri: props.simul?.info?.peri,
			status: props.simul?.info?.status ?? 10,
			pending: Glob.clone(resources),
			resCount: resources.length,
			max: Math.round(resources.length * 1.2),
			step: 10,
			progress: 0
		};
		if ( resources.length > 500 ) this.state.step = 50;
		this.load = this.load.bind(this);
	}
	componentDidMount() {
		setTimeout( this.load )
	}
	load() {
		const pending = this.state.pending;
		if ( pending.length > 0 ) {
			const nextIDs = [];
			while( pending.length > 0 && nextIDs.length < this.state.step ) {
				nextIDs.push(pending.shift());
			}
			this.setState({ pending: pending, message: <TextLabel value={"Resources"} /> }, ()=>{
				appLib.api( "simul/risorsa-uc2", { peri: this.state.peri, id: nextIDs }).then( () => {
					this.setState({ progress: this.state.progress + nextIDs.length }, this.load);
				}).catch( err => {
					console.log(err);
				});
			});
		} else {
			this.setState({ message: <TextLabel value={"Use-Case 2"} />, progress: this.state.resCount }, ()=>{
				appLib.api("simul/trigger", { id: this.props.simul.id, finalize: true }).then( this.props.end );
			});
		}
	}
	render() {
		if ( ! this.state.message ) return null;
		return (
			<div className={prefix + "-card"}>
				<h5>
					{ this.state.message }
				</h5>
				<Progress animated striped
					max={this.state.max}
					value={this.state.progress}
				/>
				<div className={"text-end mt-3"}>
					<Button onClick={ this.props.stop }>
						<TextLabel value={"Stop"} />
					</Button>
				</div>
			</div>
		)
	}
}

const SimulationFlowReady = class extends Component {
	constructor(props) {
		super(props);
		this.state = {
			simul: props.simul,
			lang: Glob.getLanguage(),
		};
		this.uid = Glob.generateUid(prefix);
		this.startSimulation = this.startSimulation.bind(this);
		this.checkEnv = this.checkEnv.bind(this);
		this.renderInfo = this.renderInfo.bind(this);
		this.renderTriggers = this.renderTriggers.bind(this);
		this.renderTriggers1 = this.renderTriggers1.bind(this);
		this.renderTriggers2 = this.renderTriggers2.bind(this);
		this.strategicAssociations = this.strategicAssociations.bind(this);
		this.loadAssociazioni = this.loadAssociazioni.bind(this);
		this.setAssociazione = this.setAssociazione.bind(this);
	}
	componentDidMount() {
		Glob.register('Prefs', () => {
			const l = Glob.getLanguage();
			if ( l !== this.state.lang ) this.setState({ lang: l });
		}, this.uid);
		setTimeout( this.checkEnv );
		if ( this.props.simul.info.cycle === 2 ) setTimeout( this.loadAssociazioni )
	}
	componentWillUnmount() {
		Glob.deregister(this.uid);
	}
	checkEnv() {
		const ns = { canStart: false, simType: undefined };
		const info = this.state.simul?.info || {};
		const status = this.state.simul?.status || 10;
		const trigger = this.state.simul?.trigger || {};
		ns.simType = info.type;
		if ( ns.simType === 1 ) {
			ns.canStart = (trigger.parsed||[]).length > 0;
		} else if ( ns.simType === 2 ) {
			ns.canStart = status > 40 && (trigger.parsed||[]).length > 0;
		}
		if ( ns.canStart && status ) ns.canStart = status < 50;
		if ( ns.canStart && this.state.associazioni ) {
			ns.canStart = ! Object.values(this.state.associazioni).some( a => a.value.length === 0 ) ;
		}
		this.setState( ns );
	}
	startSimulation() {
		const id = this.state.simul?.id;
		if (!id) return;
		this.setState({ starting: true }, async ()=>{
			if ( this.state.associazioni ) {
				const ass = [];
				Object.entries(this.state.associazioni).forEach(([key, value]) => {
					const e = structuredClone(value);
					e.id = key;
					ass.push(e);
				});
				for( const asso of ass ) {
					await appLib.api("simul/set-associazione", { id : this.state.simul.id, asso: { id: asso.id, value: asso.value} });
				}
			}
			appLib.api('simul/start', { id: id }).then((res) => {
				this.props.afterSave(res);
				Glob.setCurrentPageParam('step', 'running');
			}).catch(err => {
				console.warn(err);
			}).finally( ()=>{
				this.setState({ starting: false });
			});
		});
	}
	renderTriggers1(items) {
		items.sort( (a, b) => (a.subjectLabel||'').localeCompare(b.subjectLabel||'') );
		return (
			<div className={prefix + "-card"}>
				<h5>
					<TextLabel value={"Trigger"} />
				</h5>
				<table className={prefix + "-table"}>
					<thead>
					<tr>
						<th><TextLabel value={"Main subject"} /></th>
						<th><TextLabel value={"ICT good"} /></th>
						<th className={"text-center"}>C</th>
						<th className={"text-center"}>I</th>
						<th className={"text-center"}>A</th>
						<th className={"text-center"}>O</th>
					</tr>
					</thead>
					<tbody>
					{ items.map( t => (
						<tr key={ t.id }>
							<td>{ t.subjectLabel }</td>
							<td style={{fontWeight: 600}}>{ t.label }</td>
							<td className={scoreClass(t.status?.c??1)}>{ Math.round((t.status?.c??1)*100) }%</td>
							<td className={scoreClass(t.status?.i??1)}>{ Math.round((t.status?.i??1)*100) }%</td>
							<td className={scoreClass(t.status?.a??1)}>{ Math.round((t.status?.a??1)*100) }%</td>
							<td className={scoreClass(t.status?.o??1)}>{ Math.round((t.status?.o??1)*100) }%</td>
						</tr>
					) ) }
					</tbody>
				</table>
			</div>
		)
	}
	renderTriggers2(items) {
		const status = this.state.simul?.status ?? 10;
		const resLen = (this.state.simul.trigger.preparsed || []).length;
		if ( resLen > 0 && this.state.parseType2 ) {
			return (
				<ParseType2
					simul={ this.state.simul }
					stop={ ()=>{ this.setState({ parseType2: false }) }}
					end={ res => {
						this.setState({ simul: res }, ()=>{
							this.props.afterSave(res);
						});
					} }
				/>
			)
		}
		items.sort( (a, b) => (b.cve||'').localeCompare(a.cve||'') );
		return (
			<div className={prefix + "-card"}>
				<h5>
					<TextLabel value={"Trigger"} />
				</h5>
				<table className={prefix + "-table"}>
					<thead>
					<tr>
						<th><TextLabel value={"CVE"} /></th>
						<th><TextLabel value={"Main subject"} /></th>
						<th><TextLabel value={"Resource"} /></th>
						<th><TextLabel value={"Scope"} /></th>
					</tr>
					</thead>
					<tbody>
					{ items.map( t => (
						<tr key={ t.cve }>
							<td style={{fontWeight: 600}}>{ (t.cve||'').toUpperCase() }</td>
							<td>{ t.subjectLabel }</td>
							<td>{ t.risorsaLabel }</td>
							<td>{ t.scope }</td>
						</tr>
					) ) }
					</tbody>
				</table>
				{ (status < 41) ? (
					resLen > 0 ? (
						<Alert color={"warning"} fade={false}>
							<div className={"d-flex align-items-center justify-content-between"}>
								{ this.state.lang === 'it' ? (
									<span>
									Determina il trigger, l'impatto iniziale di {items.length} CVE su { resLen } risorse potenzialmente coinvolte.
								</span>
								) : (
									<span>
									Calc trigger, the initial impact of {items.length} CVEs on { resLen } resources potentially involved.
								</span>
								)}
								<Button onClick={ ()=>{ this.setState({parseType2: true }) }}>
									<TextLabel value={"Start"} />
								</Button>
							</div>
						</Alert>
					) : (
						<Alert color={"danger"} fade={false}>
							<div>
								{ this.state.lang === 'it' ? (
									<span>
										Nessuna risorsa risulta coinvolta con queste CVE.
									</span>
								) : (
									<span>
										No resource is affected by these CVE.
									</span>
								)}
							</div>
						</Alert>
					)
				) : (
					<Alert fade={false}>
						<div>
							{ this.state.lang === 'it' ? (
								<span>
										Trigger effettivo: { (this.state.simul.trigger.parsed || []).length } Risorse coinvolte da {items.length} CVE.
								</span>
							) : (
								<span>
										Actual trigger: { (this.state.simul.trigger.parsed || []).length } resources affected by {items.length} CVEs.
								</span>
							)}
						</div>
					</Alert>
				)}
			</div>
		);
	}
	renderTriggers() {
		const saved = this.state.simul?.trigger?.saved;
		if ( ! saved || ! Object.keys(saved).length ) return null;
		const items = Object.values(saved).filter( x => x && typeof x === 'object' && Object.keys(x).length > 0 );
		if ( ! items.length ) return null;
		if (this.state.simType === 1) return this.renderTriggers1(items);
		if (this.state.simType === 2) return this.renderTriggers2(items);
		return null;
	}
	renderInfo() {
		const simul = this.state.simul;
		const info = simul?.info || {};
		return(
				<div className={prefix + "-card"}>
					<h5>
						<TextLabel value={"Info"} />
					</h5>
					<div className={prefix + "-row"}>
						<span className={prefix + "-label"}>
							<TextLabel value={"Name"} />
						</span>
						<span className={prefix + "-value"}>
								{ info.name || <span className={prefix + "-value--empty"}><TextLabel value={"Not configured"} /></span> }
							</span>
					</div>
					<div className={prefix + "-row"}>
							<span className={prefix + "-label"}>
								<TextLabel value={"Simulation type"} />
							</span>
						<span className={prefix + "-value"}>
								{ (this.props.lists?.types||[]).find(t => t.value === info.type)?.label || info.type }
							</span>
					</div>
					<div className={prefix + "-row"}>
							<span className={prefix + "-label"}>
								{ simul.fake ? <AppSynthDataIcon /> : <AppPerimeterIcon /> }
								<TextLabel value={"Perimeter"} />
							</span>
						<span className={prefix + "-value"}>
								{ info.periname || info.peri || <span className={prefix + "-value--empty"}><TextLabel value={"Not configured"} /></span> }
							</span>
					</div>
					{ !!info.description && (
						<div className={prefix + "-row"}>
								<span className={prefix + "-label"}>
									<TextLabel value={"Description"} />
								</span>
							<span className={prefix + "-value"}>
									{ info.description }
								</span>
						</div>
					) }
					<div className={prefix + "-row"}>
							<span className={prefix + "-label"}>
								<TextLabel value={"Cycle"} />
							</span>
						<span className={prefix + "-value"}>
								{ (this.props.lists?.cycles||[]).find(c => c.value === info.cycle)?.label || info.cycle }
							</span>
					</div>
					<div className={prefix + "-row"}>
							<span className={prefix + "-label"}>
								<TextLabel value={"Priority"} />
							</span>
						<span className={prefix + "-value"}>
								{ (this.props.lists?.priorities||[]).find(p => p.value === info.priority)?.label || info.priority }
							</span>
					</div>
				</div>
			)
	}
	loadAssociazioni() {
		appLib.api("simul/get-associazioni", { id: this.props.simul.id }).then( x => {
			this.setState({ associazioni: Object.keys(x).length ? x : false, updateAssociazioni: Date.now() }, this.checkEnv );
		}).catch( err => console.log(err));
	}
	setAssociazione( id, value ) {
		value = (value||[]).filter( x => !! x?.item );
		appLib.api("simul/set-associazione", { id : this.state.simul.id, asso: { id: id, value: value} }).then( idx => {
			this.setState({ simul: idx }, async ()=>{
				await this.props.afterSave( idx );
				this.loadAssociazioni();
			});
		})
	}
	strategicAssociations() {
		const ass = [];
		Object.entries(this.state.associazioni).forEach(([key, value]) => {
			const e = structuredClone(value);
			e.id = key;
			ass.push(e);
		});
		ass.sort((a, b) => ( a.name.localeCompare( b.name )));
		return (
			<div
				key={this.state.updateAssociazioni}
				className={prefix + "-card"}
			>
				<h5>
					{ this.state.lang === 'it' ? 'Associazioni per il modello strategico' : 'Strategic model associations' }
				</h5>
				<div className={"associazioni"}>
					{ this.state.lang === 'it' ? (
						<p>
							Questi Soggetti compilatori sono potenzialmente coinvolti nell’evento.<br />
							È stato scelto di eseguire la simulazione anche secondo il modello strategico,
							per cui occorre verificare la corretta associazione tra i due modelli.
						</p>
					) : (
						<p>
							These main Subjects are potentially involved in the outcome of the event.<br />
							You’ve chosen to run also the Strategic Model in this simulation,
							it’s necessary to fulfill the appropriate association between the two models.
						</p>
					) }
					{ ass.map( a => (
						<AssociazioniStrategicheSoggetto
							key={a.id}
							asso={a}
							save={ v => { this.setAssociazione( a.id, v )}}
						/>
					))}
				</div>
			</div>
		)
	}

	render() {
		return (
			<>
				<div className={"panel-content limited " + prefix} id={this.uid}>
					<h3>
						<TextLabel value={"Simulation start"} />
					</h3>
					{ this.renderInfo() }
					{ this.state.associazioni && this.strategicAssociations() }
					{ this.renderTriggers() }
				</div>
				<div className={"panel-footer"}>
					<ButtonGroup className={"btn-icon"}>
						<Button
							color={"success"}
							onClick={ ()=>{ Glob.setCurrentPageParam('step', 'settings') } }
						>
							<i>
								<ChevronLeftIcon />
							</i>
							<b>
								<TextLabel value={"Settings"} />
							</b>
						</Button>
					</ButtonGroup>
					{ (!!this.state.starting) ? (
						<div style={{width:'200px'}}>
							<Progress animated={true} value={100} striped />
						</div>
					) : (
						<ButtonGroup className={"btn-icon"}>
							{ ((this.state.simul?.status || 0) < 50) && (
								<Button
									color={"primary"}
									disabled={ ! this.state.canStart }
									onClick={ this.startSimulation }
								>
									<i>
										<PlayIcon />
									</i>
									<b>
										<TextLabel value={"Start"} />
									</b>
								</Button>
							)}
							<Button
								color={"success"}
								disabled={ (this.state.simul.status || 10) < 50 }
								onClick={ ()=>{ Glob.setCurrentPageParam('step', 'running') } }
							>
								<b>
									<TextLabel value={"Running"} />
								</b>
								<i>
									<ChevronRightIcon />
								</i>
							</Button>
						</ButtonGroup>
					)}
				</div>
			</>
		)
	}
}

export default SimulationFlowReady;
